import { useMutation } from '@apollo/client'
import FooterUI, { Props } from '@interflora/ui-components/build/components/Footer/Footer'
import React, { useContext, useState, useEffect, useCallback } from 'react'
import { populateTemplateValues } from 'utils/components'
import { HandleSubmit, NewsletterSignUpValues } from '@interflora/ui-components/build/common/props'
import { NEWSLETTER_SIGNUP } from '../../graphql/queries'
import _get from 'lodash-es/get'
import { useAnalytics } from 'hooks/useAnalytics'
import { renderUniversalPixel } from '../../scripts/universalPixel'
import { isCookieTypeAccepted, SiteContext } from '@interflora/ui-components/build/utils/common'

type FooterProps = Omit<Props, 'signUp' | 'newsletterSignUp'> & { newsLetterSignUp: any }

const updateNewsLetterSignUpTemplate: NewsletterSignUpValues = {
  firstName: '',
  lastName: '',
  email: '',
}

const Footer = (props: FooterProps) => {
  const { newsLetterSignUp, ...others } = props
  const site = useContext(SiteContext)
  const [signUpMutation] = useMutation(NEWSLETTER_SIGNUP)
  const analytics = useAnalytics()
  const [isMarketingCookieAccepted, setIsMarketingCookieAccepted] = useState(false)

  // Check cookie consent status and listen for changes
  const checkCookieConsent = useCallback(() => {
    const consentStatus = isCookieTypeAccepted('C0004')
    setIsMarketingCookieAccepted(consentStatus)
  }, [])

  useEffect(() => {
    if (typeof globalThis === 'undefined') return
    checkCookieConsent()
    globalThis.addEventListener('OneTrustGroupsUpdated', checkCookieConsent)

    return () => {
      globalThis.removeEventListener('OneTrustGroupsUpdated', checkCookieConsent)
    }
  }, [checkCookieConsent])

  const newsLetterSignUpSubmitAnalytics = () => {
    analytics.newsLetterSignUpSubmit('footer')
  }

  const newsLetterSignUpOpenAnalytics = () => {
    analytics.newsLetterSignUpOpen('footer')
  }
  const signUp: HandleSubmit<NewsletterSignUpValues> = async (values) => {
    try {
      const signUpValues = { ...values, email: values.email.trim() }
      const signUpNewsletterValues = populateTemplateValues(signUpValues, updateNewsLetterSignUpTemplate)
      await signUpMutation({ variables: { input: signUpNewsletterValues } })
      newsLetterSignUpSubmitAnalytics()
    } catch (error) {
      const errMsg = _get(error, ['graphQLErrors', 0, 'message'])
      throw new Error(errMsg)
    }
  }

  const sendFooterAnalytics = (linkText: string) => {
    if (linkText) {
      analytics.sendFooterAnalytics(linkText)
    }
  }

  return (
    <>
      <FooterUI
        signUp={signUp}
        newsletterSignUp={newsLetterSignUp}
        sendFooterAnalytics={sendFooterAnalytics}
        newsLetterSignUpOpenAnalytics={newsLetterSignUpOpenAnalytics}
        {...others}
      />
      {isMarketingCookieAccepted && renderUniversalPixel(site?.shorthand ?? '')}
    </>
  )
}

export default Footer
